import { useEffect } from "react";

/**
 * Sets document.title to `ITP - <title>` when a non-empty title is provided,
 * otherwise falls back to "IT Project Management".
 *
 * Detail pages can pass null/undefined until their entity loads, then the real
 * name once available — the effect re-runs when `title` changes.
 */
export function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    if (typeof title === "string" && title.trim() !== "") {
      document.title = `ITP - ${title}`;
    } else {
      document.title = "IT Project Management";
    }
  }, [title]);
}

export default useDocumentTitle;
